<template>
  <Transition :name="animationMode">
    <span :class="[
            enableAnimation && 'animation',
            animationMode,
            `icon-${icon}${fill ? '-bold' : ''}`,
            props.disabled && '!tw-text-blue-dark-100',
            (props.pointer && !props.disabled) && '!tw-cursor-pointer'
          ]"
          @click="handleClick"
          :style="{ 'font-size': `${size}px`}"></span>
  </Transition>
</template>

<script setup>
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  fill: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [Number, String],
    default: 24,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  pointer: {
    type: Boolean,
    default: false,
  },
  enableAnimation: {
    type: Boolean,
    default: false,
  },
  animationMode: {
    type: String,
    default: 'bounce',
  },
});

const emit = defineEmits(["click"])
const handleClick = (event) => {
  if (props.disabled) {
    event.stopPropagation()
    return false
  }

  emit("click", event)
}
</script>

<style scoped>

@keyframes bounce {
  0% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-5px) scale(1.08);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

@keyframes shake {
  0%,100% { transform: rotate(0deg); }
  25% { transform: rotate(-8deg); }
  75% { transform: rotate(8deg); }
}

.animation {
  transition: all 0.2s ease;
}

.animation.bounce {
  animation: bounce 0.6s ease-in-out infinite;
}
.animation.shake {
  animation: shake 0.5s infinite;
}

</style>
